import { useCopiedState } from "../../../../core/util/hooks";
import { setFilter, removeFilter, initialState } from "../monthlyTradeUXSlice";
import { setData } from "../monthlyTradeDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";
import { MonthlyTradingReportFilter } from "../types";

export const useMTRFilter = () => {
  const storeFilter = useSelector<StoreType, MonthlyTradingReportFilter>(
    (store) => store.ux.reports.monthlyTrade.filter
  );

  const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState<
    MonthlyTradingReportFilter
  >(storeFilter);

  const dispatch = useDispatch();

  const dispatchSetFilter = React.useCallback(
    (numofmonths: number) => {
      dispatch(setFilter(numofmonths));
      dispatch(setData());
    },
    [dispatch]
  );

  const dispatchResetFilter = React.useCallback(() => {
    setCurrentFilter(initialState.filter);
  }, [setCurrentFilter]);

  return [
    filter,
    editFilter,
    dispatchSetFilter,
    changeState,
    dispatchResetFilter,
  ] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter,
    typeof changeState,
    typeof dispatchResetFilter
  ];
};
